export type AppThemeMode = "light" | "dark" | "system";

export const appThemeStorageKey = "fswl-app-theme";

export function isAppThemeMode(value: string | null): value is AppThemeMode {
  return value === "light" || value === "dark" || value === "system";
}

export function resolveAppThemeMode(value: string | null): AppThemeMode {
  return isAppThemeMode(value) ? value : "system";
}

export function getSystemThemeMode(): "light" | "dark" {
  return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}

export function resolveEffectiveTheme(mode: AppThemeMode): "light" | "dark" {
  return mode === "system" ? getSystemThemeMode() : mode;
}

export function applyAppTheme(mode: AppThemeMode = "system") {
  const effective = resolveEffectiveTheme(mode);
  document.documentElement.dataset.theme = effective;
  document.documentElement.dataset.themePreference = mode;
  document.documentElement.style.colorScheme = effective;
}

export function initAppTheme() {
  const stored = window.localStorage.getItem(appThemeStorageKey);
  applyAppTheme(resolveAppThemeMode(stored));
}

export function persistAppTheme(mode: AppThemeMode) {
  window.localStorage.setItem(appThemeStorageKey, mode);
  applyAppTheme(mode);
}

export const appThemeModeLabels: Record<AppThemeMode, string> = {
  light: "Light",
  dark: "Dark",
  system: "System",
};
